import React from 'react';
import TooltipButtonIcon from "@frontend/components/atoms/TooltipButtonIcon";
import {
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

// Componentes por eliminar: EditDeleteTooltipIconButtons
const EditDeleteTooltipIconButtons = ({
  onClickEdit,
  onClickDelete
}) => {
  return (
    <>
      <TooltipButtonIcon
        tooltipTitle="Editar"
        onClick={onClickEdit}
        icon={<EditOutlined />}
      />
      <TooltipButtonIcon
        tooltipTitle="Eliminar"
        type="danger"
        ghost
        onClick={onClickDelete}
        icon={<DeleteOutlined />}
      />
    </>
  );
};

export default EditDeleteTooltipIconButtons;
